export const text = {
  DELETE_TEXT: "Delete",
  CONFIRM_TEXT: "Confirm",
};
